import { z } from 'zod';

export const BookingPriceTierSchema = z.object({
  name: z.string(),
  participantsCount: z.number(),
  price: z.number(),
  amount: z.number(),
});
export type BookingPriceTier = z.infer<typeof BookingPriceTierSchema>;

export const BookingDayPriceTierSchema = z.object({
  priceTierId: z.string().nullable(),
  priceTierName: z.string(),
  quantity: z.number(),
  units: z.number(),
  pricePerUnit: z.number(),
  amount: z.number(),
});
export type BookingDayPriceTier = z.infer<typeof BookingDayPriceTierSchema>;
